import { Component, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { SidebarItemGroupComponent } from '../navigation-item-group/navigation-item-group.component';
import { AuthApiService } from '../../../modules/auth/services/auth-api.service';
import { AuthService } from '../../../modules/auth/services/auth.service';
import { ToastNotificationService } from '../../../notifications/services/toast-notification.service';
import { ToastNotificationType } from '../../../notifications/models/toast-notification-type';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, SidebarItemGroupComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent {

  sidebarItems = inject(NavigationService).getNavigationItems();

  minimized = input<boolean>(false);
  opened = input(false);

  toggleMinimize = output();
  close = output();

  authApiService = inject(AuthApiService);
  authService = inject(AuthService);
  translate = inject(TranslateService);

  toastNotificationService = inject(ToastNotificationService);

  get isRTL() {
    return this.translate.getCurrentLang() === 'ar';
  }

  logout() {
    this.authApiService.logout().subscribe({
      next: (response) => {
        this.close.emit();
        this.authService.logout();
      },
      error: (err) => {
        this.toastNotificationService.createNotification(
          this.translate.instant('common.errors.generic_request_failed'),
          ToastNotificationType.ERROR,
        );
      }
    });
  }
}
